export default class Gate{

 /*   constructor(user){
        this.user = user;
    }*/

    isAdmin(){        
        return $cookies.get('anch_ut') === 'admin';
    }

    isUser(){
        return $cookies.get('anch_ut') === 'user';
    }
    
    isAdminOrUser(){
        if($cookies.get('anch_ut') === 'user' || $cookies.get('anch_ut') === 'admin'){
            return true;
        }
    }
}

